import { Box, Button, Flexbox, Modal, ModalBody, ModalFooter, ModalHeader, Heading, Label } from "codekit";

/**
 * Modal de la compuerta previa a la creación del DO: Customs AI encontró
 * evidencia de que la factura y el documento de transporte NO son de la
 * misma operación. El DO todavía NO existe (ningún número quemado): el
 * usuario decide si revisa la selección o fuerza la creación (la decisión
 * forzada queda trazada y entrena al verificador como contra-ejemplo).
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-07-29
 */
const Prechemx = ({ precheck, onForce, onCancel, isLoading }) => {
  if (!precheck) {
    return null;
  }
  const detalle = Array.isArray(precheck.detalle) ? precheck.detalle : [precheck];
  return (
    <Modal isOpen size="l">
      <ModalHeader>
        <Heading variant="heading-6">Customs AI: estos documentos no parecen ser de la misma operación</Heading>
      </ModalHeader>
      <ModalBody>
        <Box mb={4}>
          <Label>
            El DO aún no se ha creado (no se generó ningún número). Revisa la evidencia:
          </Label>
        </Box>
        {detalle.map((item, index) => (
          <Box key={index} bg="neutral-200" borderColor="neutral-300" rounded="md" spacing={3} mb={3}>
            <Label>
              {item.referencia ? `Factura ${item.referencia}: ` : ""}
              {item.veredicto}
              {typeof item.confianza === "number" ? ` (confianza ${item.confianza}%)` : ""}
            </Label>
            <Box mt={2}>
              <Label>{item.justificacion}</Label>
            </Box>
            {Array.isArray(item.evidencias) && item.evidencias.length > 0 && (
              <Box mt={2}>
                {item.evidencias.map((evidencia, evidenciaIndex) => (
                  <Label key={evidenciaIndex}>• {evidencia}</Label>
                ))}
              </Box>
            )}
          </Box>
        ))}
      </ModalBody>
      <ModalFooter>
        <Flexbox justifyContent="end" gap={4}>
          <Button type="button" variant="secondary-light" onClick={onCancel} disabled={isLoading}>
            Revisar selección
          </Button>
          <Button type="button" variant="error-bold" onClick={onForce} isLoading={isLoading}>
            Crear de todas formas
          </Button>
        </Flexbox>
      </ModalFooter>
    </Modal>
  );
};

export default Prechemx;
